module.exports = __webpack_public_path__ + "static/img_4895-e0b470b77adc7a11567b2c67413677d5.webp";